/* CAINTÈ product page v2 – gallery helpers (thumb column nav, counter, mobile progress bar). */
(function () {
  // The theme's --theme-sticky-header-height is smaller than the real sticky header, which
  // cut off the top of the sticky buy box. Measure the header ourselves.
  function setHeaderVar() {
    var section = document.querySelector('.pdp-v2');
    var header = document.querySelector('.pageheader--sticky, .pageheader, .section-header');
    if (!section || !header) return;
    // header bottom edge covers the sticky announcement bar above it as well
    var rect = header.getBoundingClientRect();
    var h = Math.round(Math.max(rect.height, rect.bottom));
    if (h > 0 && h < 400) section.style.setProperty('--pdp-header-h', h + 'px');
  }
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar);
  window.addEventListener('load', setHeaderVar);
  setTimeout(setHeaderVar, 800);

  function init() {
    var section = document.querySelector('.pdp-v2');
    if (!section || !window.jQuery) return;
    var $ = window.jQuery;
    var gallery = section.querySelector('.gallery');
    if (!gallery) return;
    var $slideshow = $(gallery).find('.product-slideshow');
    if (!$slideshow.length) return;

    var tries = 0;
    (function waitForSlick() {
      if ($slideshow.hasClass('slick-initialized')) {
        setup();
      } else if (tries++ < 150) {
        setTimeout(waitForSlick, 80);
      }
    })();

    function setup() {
      var desktop = window.matchMedia('(min-width: 1041px)').matches;
      var slick = $slideshow.slick('getSlick');

      // Theme initialises carousel layouts with 2 slides per view on desktop; we want one big image.
      if (desktop && slick.options.slidesToShow !== 1) {
        $slideshow.slick('slickSetOption', { slidesToShow: 1, slidesToScroll: 1, fade: true, adaptiveHeight: true }, true);
      }

      var counterCur = section.querySelector('.pdp-thumbs-counter__current');
      var counterTot = section.querySelector('.pdp-thumbs-counter__total');
      var bar = section.querySelector('.pdp-progress__bar');
      var prevBtn = section.querySelector('.pdp-thumbs-nav__btn--prev');
      var nextBtn = section.querySelector('.pdp-thumbs-nav__btn--next');
      var thumbs = section.querySelector('.thumbnails');

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function update(idx) {
        var s = $slideshow.slick('getSlick');
        var count = s.slideCount || 1;
        if (counterCur) counterCur.textContent = pad(idx + 1);
        if (counterTot) counterTot.textContent = pad(count);
        if (bar) {
          bar.style.width = (100 / count) + '%';
          bar.style.transform = 'translateX(' + (idx * 100) + '%)';
        }
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= count - 1;
        // keep the selected thumbnail inside the scrollable column
        if (thumbs) {
          var sel = thumbs.querySelector('.thumbnail.selected');
          if (!sel) {
            // the theme only marks a thumbnail after the first slide change; mark the initial one ourselves
            var mediaId = $(s.$slides[idx]).data('media-id');
            sel = mediaId ? thumbs.querySelector('.thumbnail[data-media-id="' + mediaId + '"]') : null;
            if (sel) sel.classList.add('selected');
          }
          if (sel) {
            var top = sel.offsetTop - thumbs.offsetTop;
            var bottom = top + sel.offsetHeight;
            if (top < thumbs.scrollTop) thumbs.scrollTop = top;
            else if (bottom > thumbs.scrollTop + thumbs.clientHeight) thumbs.scrollTop = bottom - thumbs.clientHeight;
          }
        }
      }

      $slideshow.off('.pdpv2');
      $slideshow.on('afterChange.pdpv2', function (e, s, cur) { update(cur); });
      $slideshow.on('reInit.pdpv2', function (e, s) { update(s.currentSlide); });
      // selected-thumb class is set by the theme on beforeChange; run once slightly later too
      setTimeout(function () { update($slideshow.slick('getSlick').currentSlide); }, 50);
      update(slick.currentSlide);

      // Desktop: mouse wheel / trackpad over the big image steps through the images (Manière);
      // at the first/last image the wheel is left alone so the page scrolls as normal.
      if (desktop) {
        var mainImage = gallery.querySelector('.main-image');
        var wheelLock = 0, wheelAcc = 0;
        if (mainImage && !mainImage.__pdpWheel) {
          mainImage.__pdpWheel = true;
          mainImage.addEventListener('wheel', function (e) {
            if (!window.matchMedia('(min-width: 1041px)').matches) return;
            var s = $slideshow.slick('getSlick');
            var dir = e.deltaY > 0 ? 1 : -1;
            var atEnd = (dir > 0 && s.currentSlide >= s.slideCount - 1) || (dir < 0 && s.currentSlide <= 0);
            if (atEnd) return; // let the page scroll
            e.preventDefault();
            var now = Date.now();
            wheelAcc += e.deltaY;
            if (now - wheelLock < 550 || Math.abs(wheelAcc) < 30) return;
            wheelLock = now;
            wheelAcc = 0;
            $slideshow.slick(dir > 0 ? 'slickNext' : 'slickPrev');
          }, { passive: false });
        }
      }

      // slick measures the slide height before the grid has settled; re-measure once layout is final
      var remeasure = function () { try { $slideshow.slick('setPosition'); } catch (err) {} };
      setTimeout(remeasure, 300);
      setTimeout(remeasure, 1200);
      window.addEventListener('load', remeasure);

      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); $slideshow.slick('slickPrev'); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); $slideshow.slick('slickNext'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // theme editor re-renders the section
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();
